import { applicationImpoundsApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_IMPOUNDS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/impounds`,
  {
    GET_IMPOUNDS: 'GET_IMPOUNDS',
    EDIT_IMPOUNDS: 'EDIT_IMPOUNDS',
  },
);

export const getLoanImpoundsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationImpoundsApi.getImpounds(params);

  return dispatch({
    type: LOAN_IMPOUNDS_ACTION_TYPE.GET_IMPOUNDS,
    payload: data,
  });
});

export const editLoanImpoundsAction = params => async dispatch => {
  const { data } = await applicationImpoundsApi.editImpounds(params);

  return dispatch({
    type: LOAN_IMPOUNDS_ACTION_TYPE.EDIT_IMPOUNDS,
    payload: data,
  });
};
